import ImageGallery from "react-image-gallery";
import React, { useState, useEffect } from "react";
import "../../Style/image-gallery.scss";
import Grid from "@material-ui/core/Grid";
import PruebaGoogleMaps from "../PruebaGoogleMaps";
import Typography from "@material-ui/core/Typography";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import CloseIcon from "@material-ui/icons/Close";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(0),
    margin: "auto",
    maxWidth: "1200px",
  },
  buttonDestacado: {
    color: "#FE5215",
    fontSize: "9px",
    borderColor: "#FE5215",
    paddingTop: "0px",
    paddingBottom: "0px",
  },
  paperAmenities: {
    width: "100%",
  },
  TituloHotel: {
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
  },
  HotelAddress: {
    color: "#016AA2",
    fontStyle: "oblique",
    verticalAlign: "top",
    paddingBottom: 7,
  },
  paperInterno: {
    width: 350,
    backgroundColor: "transparent",
  },
  separador: {
    marginBottom: 15,
    marginTop: 20,
  },
  fondo: {
    backgroundColor: "white",
  },
  gallery: {
    height: "436px",
  },
  fondoImage: {
    backgroundColor: "#e3f2fd",
    overflow: "hidden",
    height: "436px",
  },
  expansion: {
    backgroundColor: "#90caf9",
    // color: 'white'
  },
  TituloNombre: {
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
  },
  listitemicon: {
    minWidth: "30px",
    paddingTop: "0px",
    paddingBottom: "0px",
  },
}));

/* const appBar = {
  position: "relative",
  backgroundColor: "white",
}; */

const CheckGroup = (data, criterio) => {
  console.log(data.findIndex((element) => element.Grupo == criterio));
  return data.findIndex((element) => element.Grupo == criterio) !== -1
    ? true
    : false;
};

export default function HotelDetails(item) {
  const [columnas, setColumnas] = useState([]);
  const [descripcionLarga, setDescripcionLarga] = useState("");
  const [imagenes, setImagenes] = useState([]);
  const [HotelDetailsData, setHotelDetailsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // const [open, setOpen] = React.useState(false);
  const parseHtml = require("html-react-parser");

  const handleClose = () => {
    item.onClick()
  }; 

  const SearchDetails = () => {
    var ColumnnaX = [];
    var Imagenes = [];
    const URL =
      "https://webtravel2-online.com/APIhoteles/api/DetalleHotelRetrieve?codigo=" + item.hotel.hotel[0].code + "&Operador=" + item.hotel.hotel[0].Operador + "&destino=" + item.hotel.hotel[0].DestinationCode;
      
    //const URL = 'https://webtravel2-online.com/APIhoteles/api/DetalleHotelRetrieve?codigo=JP148467&Operador=W2M'
    console.log(URL);
    
    axios
      .get(URL, {})
      .then((response) => {
       /*  console.log(response);
        console.log("Data SearchDetails");
       
        console.log(response.data[0].DescripcionLarga.replace('\n','<br/>')); */

        setImagenes([]);
        response.data[0].Imagenes.map((item) => {
          //console.log(item.url);
          Imagenes.push({ original: item.url, thumbnail: item.url });
        });
        setImagenes(Imagenes);
        if (response.data[0].DescripcionLarga === "") {
          setDescripcionLarga(item.hotel.hotel[0].DescripcionHotel.replace('\n','<br/>').replace('\n','<br/>'));
        } else {
          setDescripcionLarga(response.data[0].DescripcionLarga.replace('\n','<br/>').replace('\n','<br/>'));
        } 
        
        if (response.data[0].Instalaciones !== null) {

   
        switch (item.hotel.hotel[0].Operador) {
          case "W2M":
            if (CheckGroup(response.data[0].Instalaciones, "Hotel"))
              ColumnnaX.push({ Columna: 1, Grupo: "Hotel" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Languages spoken"
              )
            )
              ColumnnaX.push({ Columna: 1, Grupo: "Hotel, Languages spoken" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Getting around"
              )
            )
              ColumnnaX.push({ Columna: 1, Grupo: "Hotel, Getting around" });
            if (
              CheckGroup(response.data[0].Instalaciones, "Hotel, For the kids")
            )
              ColumnnaX.push({ Columna: 1, Grupo: "Hotel, For the kids" });
            if (CheckGroup(response.data[0].Instalaciones, "CAT"))
              ColumnnaX.push({ Columna: 1, Grupo: "CAT" });
            if (CheckGroup(response.data[0].Instalaciones, "SPT"))
              ColumnnaX.push({ Columna: 1, Grupo: "SPT" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Things to do, ways to relax"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Things to do, ways to relax",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Services and conveniences"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Services and conveniences",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Things to do & ways to relax"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Things to do & ways to relax",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Fitness & recreation"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Fitness & recreation",
              });
            if (
              CheckGroup(response.data[0].Instalaciones, "Hotel, Land sports")
            )
              ColumnnaX.push({ Columna: 1, Grupo: "Hotel, Land sports" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Swimming & soaking"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Swimming & soaking",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Dining, drinking, and snacking"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Dining, drinking, and snacking",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Dining, drinking & and snacking"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Dining, drinking & and snacking",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Hotel, Available in all rooms"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Hotel, Available in all rooms",
              });
            if (CheckGroup(response.data[0].Instalaciones, "Cuarto"))
              ColumnnaX.push({ Columna: 1, Grupo: "Cuarto" });
            break;
          case "HOTELSPRO":
            if (CheckGroup(response.data[0].Instalaciones, "Location"))
              ColumnnaX.push({ Columna: 1, Grupo: "Location" });
            if (CheckGroup(response.data[0].Instalaciones, "Transportation"))
              ColumnnaX.push({ Columna: 1, Grupo: "Transportation" });
            if (CheckGroup(response.data[0].Instalaciones, "Pools & Wellness"))
              ColumnnaX.push({ Columna: 1, Grupo: "Pools & Wellness" });
            if (CheckGroup(response.data[0].Instalaciones, "Beach"))
              ColumnnaX.push({ Columna: 1, Grupo: "Beach" });
            if (CheckGroup(response.data[0].Instalaciones, "Policy"))
              ColumnnaX.push({ Columna: 1, Grupo: "Policy" });
            if (CheckGroup(response.data[0].Instalaciones, "Parking"))
              ColumnnaX.push({ Columna: 1, Grupo: "Parking" });
            if (CheckGroup(response.data[0].Instalaciones, "General"))
              ColumnnaX.push({ Columna: 1, Grupo: "General" });
            if (CheckGroup(response.data[0].Instalaciones, "Payment"))
              ColumnnaX.push({ Columna: 1, Grupo: "Payment" });
            if (CheckGroup(response.data[0].Instalaciones, "Hotel Services"))
              ColumnnaX.push({ Columna: 2, Grupo: "Hotel Services" });
            if (CheckGroup(response.data[0].Instalaciones, "Shopping"))
              ColumnnaX.push({ Columna: 2, Grupo: "Shopping" });
            if (
              CheckGroup(response.data[0].Instalaciones, "Activities & Sports")
            )
              ColumnnaX.push({ Columna: 2, Grupo: "Activities & Sports" });
            if (CheckGroup(response.data[0].Instalaciones, "Hotel Facilities"))
              ColumnnaX.push({ Columna: 2, Grupo: "Hotel Facilities" });
            if (CheckGroup(response.data[0].Instalaciones, "Entertainment"))
              ColumnnaX.push({ Columna: 2, Grupo: "Entertainment" });
            if (CheckGroup(response.data[0].Instalaciones, "Food & Drink"))
              ColumnnaX.push({ Columna: 3, Grupo: "Food & Drink" });
            if (CheckGroup(response.data[0].Instalaciones, "Internet"))
              ColumnnaX.push({ Columna: 3, Grupo: "Internet" });
            if (CheckGroup(response.data[0].Instalaciones, "Rooms)"))
              ColumnnaX.push({ Columna: 3, Grupo: "Rooms" });
            break;
          //case "HOTELBEDS":
          default:
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Green Programmes - América"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Green Programmes - América",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Green Programmes - Asia-Pacífico"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Green Programmes - Asia-Pacífico",
              });
            if (CheckGroup(response.data[0].Instalaciones, "Tipo de hotel"))
              ColumnnaX.push({ Columna: 1, Grupo: "Tipo de hotel" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Green Programmes - Europa"
              )
            )
              ColumnnaX.push({
                Columna: 1,
                Grupo: "Green Programmes - Europa",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Equipamiento de habitaciones (habitación estándar)"
              )
            )
              ColumnnaX.push({
                Columna: 2,
                Grupo: "Equipamiento de habitaciones (habitación estándar)",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Green Programmes - Mundial"
              )
            )
              ColumnnaX.push({
                Columna: 2,
                Grupo: "Green Programmes - Mundial",
              });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Posibilidades de pago"
              )
            )
              ColumnnaX.push({ Columna: 2, Grupo: "Posibilidades de pago" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Distancia (en metros)"
              )
            )
              ColumnnaX.push({ Columna: 2, Grupo: "Distancia (en metros)" });
            if (CheckGroup(response.data[0].Instalaciones, "Puntos de interés"))
              ColumnnaX.push({ Columna: 2, Grupo: "Puntos de interés" });
            if (CheckGroup(response.data[0].Instalaciones, "Ubicación"))
              ColumnnaX.push({ Columna: 3, Grupo: "Ubicación" });
            if (
              CheckGroup(
                response.data[0].Instalaciones,
                "Green Programmes - África"
              )
            )
              ColumnnaX.push({
                Columna: 3,
                Grupo: "Green Programmes - África",
              });
            if (CheckGroup(response.data[0].Instalaciones, "Salud y Belleza"))
              ColumnnaX.push({ Columna: 3, Grupo: "Salud y Belleza" });
            if (CheckGroup(response.data[0].Instalaciones, "Entretenimiento"))
              ColumnnaX.push({ Columna: 3, Grupo: "Entretenimiento" });
            if (CheckGroup(response.data[0].Instalaciones, "Instalaciones"))
              ColumnnaX.push({ Columna: 1, Grupo: "Instalaciones" });
            if (CheckGroup(response.data[0].Instalaciones, "Negocios"))
              ColumnnaX.push({ Columna: 3, Grupo: "Negocios" });
            if (CheckGroup(response.data[0].Instalaciones, "Restauración"))
              ColumnnaX.push({ Columna: 1, Grupo: "Restauración" });

            break;          
        }
        setColumnas(ColumnnaX);

        setHotelDetailsData(response.data[0].Instalaciones);
        //setHotelDetailsData(HotelDetailsDataX);
      }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    SearchDetails();
  }, []);

  function capitalizarPalabras(val) {
    if (typeof val === "undefined" || val === "") {
      return "";
    } else {
      try {
        return val
          .toLowerCase()
          .trim()
          .split(" ")
          .filter((item) => item.trim() !== "")
          .map((v) => v[0].toUpperCase() + v.substr(1))
          .join(" ");
      } catch (error) {
        console.error("errortoUpper");
        console.error(error);
      }
    }
  }

  const classes = useStyles();

  return (
    <div className={classes.fondo}>
      <Container maxWidth="lg">
        <Box display="flex" p={1} style={{ width: "100%" }}>
          <Box flexGrow={1}>
            <Typography variant="h6" className={classes.TituloHotel}>
              {capitalizarPalabras(item.hotel.hotel[0].nombreHotel)}
            </Typography>
            <Typography
              gutterBottom
              variant="subtitle1"
              className={classes.HotelAddress}
            >
              <LocationOnIcon
                fontSize="small"
                className={classes.HotelAddress}
              ></LocationOnIcon>
              {capitalizarPalabras(item.hotel.hotel[0].Direccion)}
            </Typography>
            {/*  <Typography variant="subtitle1" className={classes.TituloHotel}>
              <span>
                <img src={item.countryFlag} width="20px" alt="País"></img>
              </span>{" "}
              {item.zoneName}
            </Typography> */}
          </Box>
          <Box p={1} display="flex" alignItems="center">
            <Grid
              container
              direction="column"
              justify="flex-end"
              alignItems="flex-end"
            >
              <Grid item>
              <Link href="#" onClick={handleClose}>
                      <CloseIcon fontSize="mediun" style={{color: "#016AA2"}} />
                    </Link>
              </Grid>
              <Grid item>
                {item.hotel.hotel[0].categoriaMapeada != "1" &&
                item.hotel.hotel[0].categoriaMapeada != "2" &&
                item.hotel.hotel[0].categoriaMapeada != "3" &&
                item.hotel.hotel[0].categoriaMapeada != "4" &&
                item.hotel.hotel[0].categoriaMapeada != "5" ? (
                  <div></div>
                ) : (
                  <Rating
                    name="size-small"
                    value={parseInt(item.hotel.hotel[0].categoriaMapeada)}
                    size="small"
                    readOnly={true}
                    emptyIcon={<StarBorderIcon fontSize="inherit" />}
                  />
                )}
                {/*   {getStarImage(
                          resultX.hotel[0].categoriaMapeada,
                          resultX.hotel[0].categoria
                        )} */}
              </Grid>
              {item.hotel.hotel[0].destacado ? (
                <React.Fragment>
                  <Grid item>
                    <Button
                      size="small"
                      variant="outlined"
                      className={classes.buttonDestacado}
                    >
                      Hotel destacado{" "}
                      <ThumbUpAltIcon
                        style={{
                          color: " #FE5215",
                          paddingLeft: "3px",
                          fontSize: "12px",
                        }}
                      />
                    </Button>
                  </Grid>
                </React.Fragment>
              ) : (
                /*   <Fragment>
                          <Tooltip title="Hotel destacado" arrow>
                            <ThumbUpAltIcon style={{ color: " #FE5215" }} />
                          </Tooltip>
                        </Fragment> */
                <div></div>
              )}
            </Grid>
          </Box>
        </Box>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} lg={12}>
            {/* <Typography variant="body2" component="p"> */}
              {item.hotel.hotel[0].DescripcionHotel == null
                ? "Sin descripción"
                : parseHtml(descripcionLarga)}
            {/* </Typography> */}
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <Divider variant="middle" className={classes.separador} />
          </Grid>
          <Grid item xs={6} sm={6} lg={6}>
            <div className={classes.fondoImage}>
              <ImageGallery
                items={imagenes}
                className={classes.gallery}
                autoPlay="true"
              />
            </div>
          </Grid>
          <Grid item xs={6} sm={6} lg={6}>
            <PruebaGoogleMaps
              hotel={item.hotel.hotel[0]}
              bar={false}
            ></PruebaGoogleMaps>
          </Grid>
        </Grid>

        <Divider variant="middle" className={classes.separador} />
        {isLoading && (
          <React.Fragment>
            <Box
              display="flex"
              justifyContent="center"
              verticalAlign="center"
              m={1}
              p={1}
              css={{ width: "100%" }}
            >
              <CircularProgress
                style={{ color: "#016AA2 ", padding: "20px", margin: "auto" }}
              />
            </Box>
            <Divider variant="middle" className={classes.separador} />
          </React.Fragment>
        )}
        {columnas.length > 0 && HotelDetailsData.length > 0 ? (
          <React.Fragment>
            <Typography
              variant="h6"
              className={classes.TituloHotel}
              style={{ paddingBottom: "15px", fontWeight: "bold" }}
            >
              Más Información
            </Typography>
            <Grid container className={classes.root} spacing={2}>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={2}>
                  {[1, 2, 3].map((indice) => (
                    <Grid key={indice} item>
                      <Paper className={classes.paperInterno} elevation={0}>
                        {columnas
                          .filter((s) => s.Columna === indice)
                          .map((value, i) => (
                            <React.Fragment>
                              <Typography
                                variant="body1"
                                className={classes.TituloNombre}
                                style={{ paddingTop: "10px" }}
                              >
                                {value.Grupo}
                              </Typography>
                              <List dense="true" paddingBottom="1%">
                                {HotelDetailsData.filter(
                                  (s) => s.Grupo === value.Grupo
                                ).map((item, i) => (
                                  <ListItem>
                                    <ListItemIcon
                                      className={classes.listitemicon}
                                    >
                                      <CheckCircleOutlineIcon
                                        fontSize="small"
                                        style={{ color: "#FE5215" }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText primary={item.Descripcion} />
                                  </ListItem>
                                ))}
                              </List>
                            </React.Fragment>
                          ))}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        ) : null}
      </Container>
    </div>
  );
}
